var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonIndustry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5971 4.67115C23.4668 4.59351 23.319 4.55264 23.1686 4.55264C23.0181 4.55264 22.8703 4.59351 22.74 4.67115L15.4286 8.41308V5.42308C15.4281 5.27228 15.3903 5.12411 15.3188 4.99262C15.2473 4.86114 15.1443 4.75071 15.0198 4.67183C14.8953 4.59295 14.7533 4.54822 14.6073 4.54191C14.4613 4.5356 14.3162 4.56791 14.1857 4.63577L6.85714 8.41308V1.88462C6.85714 1.65 6.76684 1.425 6.60609 1.2591C6.44535 1.0932 6.22733 1 6 1H0.857143C0.629814 1 0.411797 1.0932 0.251051 1.2591C0.0903058 1.425 0 1.65 0 1.88462V24H24V5.42308C24.0003 5.27274 23.9635 5.12481 23.893 4.99325C23.8225 4.86168 23.7207 4.75083 23.5971 4.67115ZM17.1429 22.2308H13.7143V16.0385H17.1429V22.2308ZM22.2857 22.2308H18.8571V15.1538C18.8571 14.9192 18.7668 14.6942 18.6061 14.5283C18.4453 14.3624 18.2273 14.2692 18 14.2692H12.8571C12.6298 14.2692 12.4118 14.3624 12.251 14.5283C12.0903 14.6942 12 14.9192 12 15.1538V22.2308H1.71429V2.76923H5.14286V11.2792L13.7143 6.85615V11.2792L22.2857 6.85615V22.2308Z",
    fill: "url(#paint0_linear_773_378)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_773_378",
    x1: 0,
    y1: 12.5,
    x2: 24,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#0B3568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#107650"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonIndustry);
export default __webpack_public_path__ + "static/media/carbon_industry.eabefb5a7f364403670f5b372cc6bb0d.svg";
export { ForwardRef as ReactComponent };